"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleResponseError = void 0;
var _webautoAuthCore = require("@tier4/webauto-auth-core");
const handleResponseError = res => {
  throw new _webautoAuthCore.ErrorResponse(JSON.stringify((0, _webautoAuthCore.filterCredentialsFromObject)(res.data)), res.config.url ?? "", res.status);
};
exports.handleResponseError = handleResponseError;
//# sourceMappingURL=handleResponseError.js.map